import React from 'react';
import PropTypes from 'prop-types';

import TableWidget from 'components/new_ui/Table';
import confirmAlert from 'components/new_ui/Alerts/confirm';
import { useParams } from 'react-router-dom';
import NoData from './NoData';
import columns from './columns';

import Actions from './Actions';

export default function Table({ assessments, refresh }) {
  const { memberId } = useParams();

  const onOpenClick = (row) => {
    window.open(row.attributes.url, '_blank').focus();
  };

  const onDeleteClick = (row) => {
    confirmAlert({
      title: 'Delete',
      text: 'Do you want to delete this asssessment?',
      confirmButtonText: 'Delete',
    }, () => {
      Actions.delete(memberId, row.id, () => {
        refresh();
      });
    });
  };

  const rowActions = [
    {
      title: 'Open',
      type: 'CUSTOM',
      iconClass: 'download-icon',
      onClick: (row) => { onOpenClick(row); },
    },
    {
      type: 'DIVIDER',
    },
    {
      title: 'Delete',
      type: 'CUSTOM',
      iconClass: 'trash-icon',
      onClick: (row) => { onDeleteClick(row); },
    },
  ];

  return (
    <TableWidget
      title="Assessments"
      columns={columns}
      data={assessments || []}
      loading={assessments === null}
      noData={<NoData />}
      selectableRows={false}
      rowActions={rowActions}
    />
  );
}

Table.propTypes = {
  assessments: PropTypes.arrayOf(PropTypes.object),
  refresh: PropTypes.func.isRequired,
};

Table.defaultProps = {
  assessments: null,
};
